import { Injector } from '@angular/core';
export class ServiceInjector {
    static Injector: Injector;
}
